// French copy, namespace `api`: error messages returned by the API to the app
// (the `code` of an error never changes, only its message).

export const api = {
  signIn: "Connectez-vous.",
  unauthorized: "Non autorisé.",
  invalidData: "Données invalides.",
  invalidRequest: "Requête invalide.",
  offerNotFound: "Offre introuvable.",
  invalidAddress: "Adresse invalide.",
  originRefused: "Origine refusée.",
  tooManyAttempts: "Trop de tentatives. Réessayez dans quelques minutes.",
  auth: {
    enterEmailAndPassword: "Renseignez votre e-mail et votre mot de passe.",
    wrongCredentials: "E-mail ou mot de passe incorrect.",
    enterEmail: "Renseignez votre e-mail.",
    emailNotSent: "L’e-mail n’a pas pu être envoyé. Réessayez plus tard.",
    resetLinkInvalid: "Le lien est invalide ou a expiré. Demandez-en un nouveau.",
    signInToChangePassword: "Connectez-vous pour changer de mot de passe.",
    googleNotConfigured: "La connexion Google n’est pas configurée sur ce serveur.",
    googleLinkInvalid: "Le lien de connexion Google est invalide ou a expiré.",
    googleFailed: "La connexion Google a échoué. Réessayez.",
    // Errors raised by shared/lib/auth.ts (`AuthError`).
    invalidEmail: "Adresse e-mail invalide.",
    passwordTooShort: (min: number) => `Le mot de passe doit contenir au moins ${min} caractères.`,
    passwordTooLong: "Le mot de passe est trop long (72 octets au plus).",
    emailTaken: "Un compte existe déjà avec cette adresse.",
    invalidProfileValue: "Valeur de profil invalide.",
    unknownProfileField: (key: string) => `Champ de profil inconnu : ${key}.`,
    googleUnverified: "Google n’a pas vérifié cette adresse e-mail.",
  },
  runs: {
    invalidId: "Identifiant invalide.",
    signIn: "Connectez-vous pour suivre une analyse.",
    notFound: "Analyse introuvable.",
    stale: "Passage interrompu avant la fin. Relancez-le.",
  },
  analyze: {
    signIn: "Connectez-vous pour lancer une analyse.",
    /** `detail`: which key is missing (shared/lib/llm.ts, French). */
    modelUnavailable: (detail: string) => `${detail} Ajoutez-la dans .env.local ou utilisez la démonstration.`,
    noOffer: "Aucune offre à analyser : ajoutez-en une depuis « Mes offres ».",
    alreadyRunning: "Un passage est déjà en cours sur cette offre.",
    cooldown: (hours: number) =>
      `Le dernier passage sur cette offre date de moins de ${hours} h : l’agent ne trouverait pas de signal nouveau.`,
    runNotSaved: "Impossible d’enregistrer le passage. Réessayez dans un instant.",
    startFailed: "Impossible de démarrer l’analyse.",
  },
  billing: {
    unknownPlan: "Plan inconnu.",
    invalidCheckoutSession: "Session de paiement invalide.",
    unavailable: "Le paiement en ligne n’est pas encore disponible. Écrivez-nous.",
    planNames: { free: "Gratuit", solo: "Solo", pro: "Pro" },
    limits: {
      maxOffers: (plan: string, max: number) =>
        max === 1
          ? `Le plan ${plan} suit une seule offre. Passez à Solo pour en suivre davantage.`
          : `Le plan ${plan} suit ${max} offres au plus. Archivez-en une ou changez de plan.`,
      manualRuns:
        "Au plan Gratuit, la veille repasse chaque mois sur votre offre. Passez à Solo pour relancer un passage quand vous le voulez.",
      noSubscription: "Aucun abonnement à gérer : choisissez d’abord un plan.",
    },
  },
  feedback: {
    signIn: "Connectez-vous pour donner votre avis.",
    runNotFound: "Analyse introuvable.",
    organizationUnknown: "Organisation inconnue de la mémoire.",
  },
  linkPreview: {
    pageStatus: (status: number) => `La page a répondu ${status}.`,
  },
  track: {
    invalidEvent: "Événement invalide.",
  },
};
